export const CHANGE_VP_CHIPS = 'CHANGE_VP_CHIPS';
export const TOGGLE_BUILDING_BUILT = 'TOGGLE_BUILDING_BUILT';
export const TOGGLE_BUILDING_HAS_WORKER = 'TOGGLE_BUILDING_HAS_WORKER';
export const SET_BONUS_INPUT = 'SET_BONUS_INPUT';
